export const initialAuditLogs = [
  {
    id: "AUD-2026-1001",
    user: "Narayan Rao Hegde (Owner)",
    role: "Owner / Admin",
    action: "Approved Stock Adjustment",
    module: "Inventory",
    timestamp: "2026-08-08 17:15:30",
    details: "Approved physical reconciliation for Sona Masoori Rice (+10 bags variance accounted in Kattedan Hub)."
  },
  {
    id: "AUD-2026-1002",
    user: "Anand Deshmukh",
    role: "Retail Shop Staff",
    action: "Completed POS Sale",
    module: "Sales / POS",
    timestamp: "2026-08-08 16:20:00",
    details: "Generated invoice POS-2026-8801 for ₹766 via PhonePe UPI in Kukatpally Store."
  },
  {
    id: "AUD-2026-1003",
    user: "Venkateshwar Reddy",
    role: "Warehouse Manager",
    action: "Dispatched Stock Transfer",
    module: "Stock Transfer",
    timestamp: "2026-08-08 12:40:12",
    details: "Dispatched 120 units on TRF/WH1-WH2/0805 to Begum Bazar Depot via Truck TS-07-CP-9011."
  },
  {
    id: "AUD-2026-1004",
    user: "Swathi Kulkarni",
    role: "Accountant / Finance",
    action: "Recorded Supplier Payment",
    module: "Finance",
    timestamp: "2026-08-05 14:10:05",
    details: "Processed ₹75,000 NEFT settlement to Gemini Edibles & Fats (Freedom Oil, Hyderabad)."
  },
  {
    id: "AUD-2026-1005",
    user: "Vikas Goud",
    role: "Warehouse Staff",
    action: "Completed GRN Putaway",
    module: "Receiving / GRN",
    timestamp: "2026-08-04 11:30:22",
    details: "Verified 90 bags of Sona Masoori Rice at Kattedan Hub into Bin A1-S1-B1 under batch BAT-HYD-SONA-2608."
  }
];
